<template>
    <section id="faqs" class="faqs" v-if="faqs">
        <div class="wrapper">
            <h2>Frequently Asked Questions</h2>
            <div
                class="faq"
                v-for="(faq, index) in faqs"
                :key="faq.id"
                @click="toggleOpenDrawer(index)"
            >
                <div class="faq__question">
                    {{ faq.question }}
                    <span
                        class="icon icon-icon-donate"
                        :class="
                            isOpenDrawer == index ? 'faq_open' : 'faq_closed'
                        "
                    ></span>
                </div>
                <div class="faq__answer" v-show="isOpenDrawer == index">
                    {{ faq.answer }}
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            faqs: null,
            isOpenDrawer: null,
        }
    },
    mounted() {
        this.getFaqs()
    },
    methods: {
        getFaqs() {
            axios
                .get(`${this.$basePath}data/faqs.json`)
                .then((result) => {
                    this.faqs = result.data.faqs
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        toggleOpenDrawer(index) {
            this.isOpenDrawer = this.isOpenDrawer == index ? null : index
        },
    },
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 1138px;
}
h2 {
    font-size: 3.375rem;

    @include mobile {
        font-size: 2.8rem;
    }
}
.faq {
    border-top: 1px solid #cccccc;
    padding: 2rem 0;
    cursor: pointer;

    &__question {
        @include titleText();
        font-size: 1.5rem;
        width: 100%;
        display: flex;
        justify-content: space-between;

        @include mobile {
            line-height: 1.3;
            font-size: 1.3rem;
        }
    }

    &__answer {
        margin-top: 2rem;
        max-width: 946px;
    }

    .icon {
        color: var(--primary_colour);
        margin-right: 0;
        margin-left: auto;
        display: flex;
        align-items: center;
    }

    .faq_closed {
        transform: rotate(180deg);
    }
}
</style>
